import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem, inPixels } from '../utils/helpers/style.js';
import { spacingNumerical } from '../constants/spacing.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sizingsNative = {
  s: {
    height: 48,
    content: {
      paddingTop: 8,
      paddingBottom: 14
    }
  },
  m: {
    height: 56,
    content: {
      paddingTop: 16,
      paddingBottom: 14
    }
  },
  l: {
    height: 64,
    content: {
      paddingTop: 16,
      paddingBottom: 14
    }
  }
};
var accordionThemeNative = {
  backgroundColor: 'background.secondary',
  borderRadius: 'borders.radius',
  borderColor: {
    active: 'primary',
    inactive: 'border.inactive'
  },
  color: 'primary',
  fontColor: 'text',
  sizings: sizingsNative
};
var sizingsWeb = {
  s: {
    fontSize: px2rem(16),
    height: inPixels(48),
    button: {
      paddingVertical: inPixels(12)
    },
    content: {
      paddingVertical: inPixels(spacingNumerical.xxs),
      paddingTop: inPixels(spacingNumerical.xxxs)
    }
  },
  m: {
    fontSize: px2rem(18),
    height: inPixels(56),
    button: {
      paddingVertical: inPixels(14)
    },
    content: {
      paddingVertical: inPixels(spacingNumerical.xxs),
      paddingTop: inPixels(spacingNumerical.xxs)
    }
  },
  l: {
    fontSize: px2rem(18),
    height: inPixels(64),
    button: {
      paddingVertical: inPixels(18)
    },
    content: {
      paddingVertical: inPixels(spacingNumerical.xxs),
      paddingTop: inPixels(spacingNumerical.xxs)
    }
  }
};
var accordionAttributesWeb = {
  /**
   * Background color of the button and the opened container element
   */
  backgroundColor: 'background.secondary',
  borders: {
    active: 'primary',
    inactive: 'border.inactive',
    radius: 'borders.radius',
    style: 'full'
  },
  plainColor: 'primary',
  fontColor: 'text',
  fontSize: px2rem(18),
  height: px2rem(64),
  content: {
    paddingHorizontal: px2rem(14),
    borderless: {
      paddingHorizontal: px2rem(16)
    }
  },
  sizings: sizingsWeb
};
var accordionThemeWeb = _objectSpread(_objectSpread({}, accordionAttributesWeb), {}, {
  variants: {
    condensed: {
      borders: {
        style: 'bottomOnly'
      }
    }
  }
});

export { accordionThemeNative, accordionThemeWeb };
